import { LOCALE } from './activity-constants'

// PARA CANJEA SIN TILDE ESTOS PAISES
const canjea = ['es-PE', 'es-CL'].includes(LOCALE)
// PARA CANJEÁ CON TILDE ESTOS PAISES
const canje_a = ['es-AR', 'es-PY', 'es-UY'].includes(LOCALE)

export const $Redimir = canjea || canje_a ? 'Canjear' : 'Redimir'
export const $redimir = canjea || canje_a ? 'canjear' : 'redimir'
export const $Redime = canje_a ? 'Canjeá' : canjea ? 'Canjea' : 'Redime'
export const $redime = canje_a ? 'canjeá' : canjea ? 'canjea' : 'redime'

//Cambio de palabra pena por vergüenza
const verguenza = ['es-CL', 'es-PR', 'es-DO'].includes(LOCALE)

// GLOSARIO ARGENTINIZADO
const argen = ['es-AR', 'es-PY', 'es-UY'].includes(LOCALE)
export const WORDS = {
  Activa: argen ? 'Activá' : 'Activa',
  Atrapa: argen ? 'Atrapá' : 'Atrapa',
  aqui: argen ? 'acá' : 'aquí',
  Aqui: argen ? 'Acá' : 'Aquí',
  avanza: argen ? 'avanzá' : 'avanza',
  atrapes: argen ? 'atrapés' : 'atrapes',
  atrapas: argen ? 'atrapás' : 'atrapas',
  debes: argen ? 'debés' : 'debes',
  dejes: argen ? 'dejés' : 'dejes',
  derribes: argen ? 'derribés' : 'derribes',
  derriba: argen ? 'derribá' : 'derriba',
  Eres: argen ? 'Sos' : 'Eres',
  Escoge: argen ? 'Escogé' : 'Escoge',
  Escojas: argen ? 'Escojás' : 'Escojas',
  escojas: argen ? 'escojás' : 'escojas',
  Escapa: argen ? 'Escapá' : 'Escapa',
  empieces: argen ? 'empecés' : 'empieces',
  gana: argen ? 'ganá' : 'gana',
  Gana: argen ? 'Ganá' : 'Gana',
  Ganas: argen ? 'Ganás' : 'Ganas',
  ganes: argen ? 'ganés' : 'ganes',
  Haz: argen ? 'Hacé' : 'Haz',
  inicia_sesion: argen ? 'Iniciá sesión' : 'Inicia sesión',
  ingresa: argen ? 'ingresá' : 'ingresa',
  Ingresa: argen ? 'Ingresá' : 'Ingresa',
  juega: argen ? 'Jugá' : 'Juega',
  Juega: argen ? 'Jugá' : 'Juega',
  Mira: argen ? 'Mirá' : 'Mira',
  menstrues: argen ? 'menstrues' : 'menstrúes',
  logras: argen ? 'lográs' : 'logras',
  olvides: argen ? 'olvidés' : 'olvides',
  tienes: argen ? 'ténes' : 'tienes',
  Tienes: argen ? 'Ténes' : 'Tienes',
  ti: argen ? 'vos' : 'ti',
  pases: argen ? 'pasés' : 'pases',
  recolecta: argen ? 'recolectá' : 'recolecta',
  Recuerda: argen ? 'Recordá' : 'Recuerda',
  Recogelos: argen ? 'Recogelos' : 'Recógelos',
  Recoge: argen ? 'Recogé' : 'Recoge',
  Revela: argen ? 'Revelá' : 'Revela',
  rindas: argen ? 'rindás' : 'rindas',
  Pasa: argen ? 'Pasá' : 'Pasa',
  puedes: argen ? 'podés' : 'puedes',
  quieres: argen ? 'querés' : 'quieres',
  Quieres: argen ? 'Querés' : 'Quieres',
  sigue: argen ? 'seguí' : 'sigue',
  verguenza: verguenza ? 'vergüenza' : 'pena',
}
